{
  "eyebrow": "Ya estás dentro",
  "title": "Bienvenido a Done-it, {{company}}.",
  "titleGeneric": "Bienvenido a Done-it.",
  "sub": "Tu prueba de 30 días de {{plan}} está activa. Tres siguientes pasos.",
  "subGeneric": "Tu cuenta está activa. Tres cosas que hacer a continuación.",
  "next1": {
    "title": "Descarga la app móvil",
    "desc": "Envía el enlace de instalación a tu equipo por SMS o email.",
    "cta": "Enviar enlace de invitación"
  },
  "next2": {
    "title": "Invita a tu equipo",
    "desc": "Importa empleados en lote desde CSV o añádelos uno a uno.",
    "cta": "Abrir administración"
  },
  "next3": {
    "title": "Mira un tour de 4 minutos",
    "desc": "Cómo configurar tu primer proyecto y tus ubicaciones.",
    "cta": "Ver vídeo"
  },
  "cta": "Ir al panel",
  "receipt": "Un recibo y un email de bienvenida están en camino a {{email}}.",
  "receiptGeneric": "Un recibo y un email de bienvenida están en camino.",
  "fallbacks": {
    "company": "tu empresa",
    "plan": "tu plan",
    "inbox": "tu bandeja de entrada"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Tu cuenta {{plan}} está activa: gratis para siempre. Tres cosas que hacer a continuación."
}
